<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("TITLES.rent_request_details") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #404b3e">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form>
        <div class="row">
          <!-- Start:: Rent Request Information Section -->
          <div class="col-12 mb-4">
            <h5
              style="
                color: #404b3e;
                border-bottom: 2px solid #404b3e;
                padding-bottom: 10px;
              "
            >
              {{ $t("TITLES.rent_request_information") }}
            </h5>
          </div>

          <!-- Start:: Rent Activity -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.rent_activity')"
            v-model.trim="data.rent_activity"
            disabled
          />
          <!-- End:: Rent Activity -->

          <!-- Start:: Status -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.status')"
            v-model.trim="data._status"
            disabled
          />
          <!-- End:: Status -->

          <!-- Start:: Notes -->
          <base-input
            v-if="data.notes"
            col="12"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.notes')"
            v-model.trim="data.notes"
            disabled
          />
          <!-- End:: Notes -->

          <!-- Start:: Tenant Information Section -->
          <div class="col-12 mt-4 mb-3">
            <h5
              style="
                color: #404b3e;
                border-bottom: 2px solid #404b3e;
                padding-bottom: 10px;
              "
            >
              {{ $t("TITLES.tenant_information") }}
            </h5>
          </div>

          <!-- Start:: Tenant Name -->
          <base-input
            v-if="data.tenant"
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.tenant_name')"
            v-model.trim="data.tenant.user.name"
            disabled
          />
          <!-- End:: Tenant Name -->

          <!-- Start:: Tenant Mobile -->
          <base-input
            v-if="data.tenant"
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.mobile')"
            v-model.trim="data.tenant.user.mobile"
            disabled
          />
          <!-- End:: Tenant Mobile -->

          <!-- Start:: Tenant Email -->
          <base-input
            v-if="data.tenant && data.tenant.user.email"
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.email')"
            v-model.trim="data.tenant.user.email"
            disabled
          />
          <!-- End:: Tenant Email -->

          <!-- Start:: Ad Information Section -->
          <div class="col-12 mt-4 mb-3">
            <h5
              style="
                color: #404b3e;
                border-bottom: 2px solid #404b3e;
                padding-bottom: 10px;
              "
            >
              {{ $t("TITLES.ad_information") }}
            </h5>
          </div>

          <!-- Start:: Ad Name -->
          <base-input
            v-if="data.ad"
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.ad_name')"
            v-model.trim="data.ad.name"
            disabled
          />
          <!-- End:: Ad Name -->

          <!-- Start:: Shop Type -->
          <base-input
            v-if="data.ad"
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.shop_type')"
            v-model.trim="data.ad._shop_type"
            disabled
          />
          <!-- End:: Shop Type -->

          <!-- Start:: Area -->
          <base-input
            v-if="data.ad"
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.area')"
            v-model.trim="data.ad.area"
            disabled
          />
          <!-- End:: Area -->

          <!-- Start:: Shop Status -->
          <base-input
            v-if="data.ad"
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.shop_status')"
            v-model.trim="data.ad._shop_status"
            disabled
          />
          <!-- End:: Shop Status -->

          <!-- Start:: Payment Due -->
          <base-input
            v-if="data.ad"
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.payment_due')"
            v-model.trim="data.ad._payment_due"
            disabled
          />
          <!-- End:: Payment Due -->

          <!-- Start:: Rent Price -->
          <base-input
            v-if="data.ad"
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.rent_price')"
            v-model.trim="data.ad.rent_price"
            disabled
          />
          <!-- End:: Rent Price -->

          <!-- Start:: Landlord Information Section -->
          <div class="col-12 mt-4 mb-3">
            <h5
              style="
                color: #404b3e;
                border-bottom: 2px solid #404b3e;
                padding-bottom: 10px;
              "
            >
              {{ $t("TITLES.landlord_information") }}
            </h5>
          </div>

          <!-- Start:: Landlord Name -->
          <base-input
            v-if="data.ad && data.ad.user && data.ad.user.user"
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.landlord_name')"
            v-model.trim="data.ad.user.user.name"
            disabled
          />
          <!-- End:: Landlord Name -->

          <!-- Start:: Landlord Mobile -->
          <base-input
            v-if="data.ad && data.ad.user && data.ad.user.user"
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.mobile')"
            v-model.trim="data.ad.user.user.mobile"
            disabled
          />
          <!-- End:: Landlord Mobile -->

          <!-- Start:: Landlord Email -->
          <base-input
            v-if="
              data.ad &&
              data.ad.user &&
              data.ad.user.user &&
              data.ad.user.user.email
            "
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.email')"
            v-model.trim="data.ad.user.user.email"
            disabled
          />
          <!-- End:: Landlord Email -->

          <!-- Start:: Landlord Type -->
          <base-input
            v-if="data.ad && data.ad.user && data.ad.user.user"
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.landlord_type')"
            v-model.trim="data.ad.user.user._landlord_type"
            disabled
          />
          <!-- End:: Landlord Type -->

          <!-- Start:: Location Section -->
          <div class="col-12 mt-4 mb-3">
            <h5
              style="
                color: #404b3e;
                border-bottom: 2px solid #404b3e;
                padding-bottom: 10px;
              "
            >
              {{ $t("TITLES.location_information") }}
            </h5>
          </div>

          <!-- Start:: Region -->
          <base-input
            v-if="data.ad && data.ad.region"
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.region')"
            v-model.trim="data.ad.region.name"
            disabled
          />
          <!-- End:: Region -->

          <!-- Start:: City -->
          <base-input
            v-if="data.ad && data.ad.city"
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.city')"
            v-model.trim="data.ad.city.name"
            disabled
          />
          <!-- End:: City -->

          <!-- Start:: District -->
          <base-input
            v-if="data.ad && data.ad.district"
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.district')"
            v-model.trim="data.ad.district.name"
            disabled
          />
          <!-- End:: District -->

          <!-- Start:: Map -->
          <div class="col-12 mb-4" v-if="data.ad && data.ad.lat && data.ad.lng">
            <h6 style="color: #404b3e; margin-bottom: 15px">
              {{ $t("PLACEHOLDERS.location_on_map") }}
            </h6>
            <div style="height: 300px">
              <MapComponent
                :latitude="parseFloat(data.ad.lat)"
                :longitude="parseFloat(data.ad.lng)"
              />
            </div>
          </div>
          <!-- End:: Map -->

          <!-- Start:: Ad Images Section -->
          <div class="col-12 mt-4 mb-3">
            <h5
              style="
                color: #404b3e;
                border-bottom: 2px solid #404b3e;
                padding-bottom: 10px;
              "
            >
              {{ $t("TITLES.ad_images") }}
            </h5>
          </div>

          <!-- Start:: Ad Images -->
          <div
            class="col-12 mb-4"
            v-if="data.ad && data.ad.images && data.ad.images.length"
          >
            <div class="row">
              <div
                class="col-4 mb-3"
                v-for="image in data.ad.images"
                :key="image.id"
              >
                <img
                  :src="image.image"
                  :alt="data.ad.name"
                  style="
                    width: 100%;
                    height: 200px;
                    object-fit: cover;
                    border-radius: 8px;
                    cursor: pointer;
                  "
                  @click="openImageModal(image.image)"
                />
              </div>
            </div>
          </div>
          <div class="col-12 mb-4" v-else>
            <p class="text-muted text-center">
              {{ $t("MESSAGES.no_images_available") }}
            </p>
          </div>
          <!-- End:: Ad Images -->
        </div>
      </form>
    </div>

    <!-- Start:: Image Modal -->
    <v-dialog v-model="imageModalIsOpen" max-width="800">
      <v-card>
        <v-card-text class="text-center">
          <img :src="selectedImage" style="max-width: 100%; max-height: 80vh" />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="modal_cancel_btn" @click="imageModalIsOpen = false">
            {{ $t("BUTTONS.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- End:: Image Modal -->
  </div>
</template>

<script>
import { mapActions } from "vuex";
import MapComponent from "@/components/general/MapComponent.vue";

export default {
  name: "ShowRentRequest",

  components: {
    MapComponent,
  },

  data() {
    return {
      // Start:: Data
      data: {},
      // End:: Data

      // Start:: Image Modal Data
      imageModalIsOpen: false,
      selectedImage: null,
      // End:: Image Modal Data
    };
  },

  methods: {
    // Start:: Vuex Actions
    ...mapActions({
      updateAppLoadingStatus: "LoadingModule/updateAppLoadingStatus",
    }),
    // End:: Vuex Actions

    // Start:: Get Data
    async getData() {
      this.updateAppLoadingStatus(true);

      try {
        let res = await this.$axios({
          method: "GET",
          url: `rent-requests/${this.$route.params.id}`,
        });
        this.updateAppLoadingStatus(false);
        this.data = res.data.data.rentRequest;
      } catch (error) {
        this.updateAppLoadingStatus(false);
        console.log(error.response?.data?.message);
        this.$message.error(
          error.response?.data?.message || this.$t("MESSAGES.failed")
        );
      }
    },
    // End:: Get Data

    // Start:: Open Image Modal
    openImageModal(imageSrc) {
      this.selectedImage = imageSrc;
      this.imageModalIsOpen = true;
    },
    // End:: Open Image Modal
  },

  created() {
    this.getData();
  },
};
</script>
